import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgStyle} from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  imports: [
    NgStyle
  ],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  @Input() value = 0;
}
